module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAApklEQVQoU6WRWw3CQBBFTx2AAyQgASnFARIqoRIqAQlIqAQcUAeQ08w0m83uF5Psz50587g70I4F+AL3Oj2EcAIewATMwDv0S6VvCdhRQDCfzFY8G40CFj6LrhbeYsKrWOmqLiApVEYLMD8LuLfvL8Dxxlo1mnorddxm6R3dArR4P9rQ1rHXNqw+bLVO7xU8Pj8teTur6+TxcZl0igd/QjjH4W6wxw/NMyQdFphSvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shape3.png
// module id = IQfb
// module chunks = 2